import React from 'react';

import Paragraph from '@/components/Paragraph';
import { ImageType } from '@/components/Image';
import { EMAIL_ADDRESS } from '@/utils/constants';
import useTranslations from '@/hooks/useTranslations';

import GenericBlock from './GenericBlock';
import SocialProviders from './SocialProviders';
import {
  EmailLink,
  FormLink,
  HorizontalSeparator,
} from './ContactBlock.styles';

const contactFormSlug = {
  en: 'form',
  nl: 'formulier',
  fr: 'formulaire',
};

type Props = {
  title: string;
  text: string;
  image: ImageType;
  formButtonText: string;
  socialProviders: string[];
  locale: string;
};

const getFormLink = (locale: string) => {
  if (typeof window === 'undefined') {
    return '';
  }

  return `${window?.location.pathname}/${contactFormSlug[locale]}`;
};

const SendMessageBlock: React.FC<Props> = (props) => {
  // prettier-ignore
  const {
    title,
    text,
    image,
    formButtonText,
    socialProviders,
    locale
  } = props;

  const { t } = useTranslations('contact');

  return (
    <GenericBlock image={image} title={title}>
      {text && <Paragraph size='lg'>{text}</Paragraph>}
      <Paragraph size='lg' margin='2rem 0 0'>
        {t('viaWebsite')}
      </Paragraph>
      <FormLink
        href={getFormLink(locale)}
        margin='.8rem 0 0'
        size='lg'
        fullWidth
      >
        {formButtonText}
      </FormLink>
      <Paragraph size='lg' margin='2rem 0 0'>
        {t('viaEmail')}
      </Paragraph>
      <EmailLink href={`mailto:${EMAIL_ADDRESS}`}>{EMAIL_ADDRESS}</EmailLink>
      <HorizontalSeparator />
      <Paragraph size='lg'>{t('contactSocialMedia')}</Paragraph>
      <SocialProviders socialProviders={socialProviders} />
    </GenericBlock>
  );
};

export default SendMessageBlock;
